export type ReadOnlyReason = 'SELF' | 'ADMIN_TARGET';

export interface ProjectPermissionEntryDTO {
  projectId: string;
  projectName: string;
  memberId: string;
  roles: string[];
  rolePermissions: string[];
  granted: string[];
  revoked: string[];
}

export interface UserProjectPermissionsDTO {
  catalog: string[];
  revocable: string[];
  editable: boolean;
  readOnlyReason: ReadOnlyReason | null;
  projects: ProjectPermissionEntryDTO[];
}

export interface UpdatePermissionOverridesRequest {
  granted: string[];
  revoked: string[];
}

export function effectivePermissions(entry: ProjectPermissionEntryDTO): string[] {
  const granted = entry.granted.filter((name) => !entry.rolePermissions.includes(name));
  return [...entry.rolePermissions, ...granted].filter((name) => !entry.revoked.includes(name));
}

export function overridesFor(
  entry: ProjectPermissionEntryDTO,
  checked: readonly string[],
  catalog: readonly string[],
): UpdatePermissionOverridesRequest {
  return {
    granted: catalog.filter((name) => checked.includes(name) && !entry.rolePermissions.includes(name)),
    revoked: catalog.filter((name) => entry.rolePermissions.includes(name) && !checked.includes(name)),
  };
}

export function samePermissions(a: readonly string[], b: readonly string[]): boolean {
  return a.length === b.length && a.every((name) => b.includes(name));
}
